export default __webpack_public_path__ + "static/media/THE_EVENING_STANDARD.528b12b8.png";